import { z } from "zod";

/**
 * Zod 4 compiles its object parsers with `new Function` where it can, and probes for that when
 * the first object schema is built. The patient app's Content-Security-Policy allows no eval,
 * and the browser reports even the caught probe as a violation. Switching the compiler off must
 * happen before any schema exists, @emr/contracts' included, so main.tsx imports this first.
 */
z.config({ jitless: true });
